import React from 'react';
import { Button, Icon, FlexBox, H2 } from '@vp/swan';

import PropTypes from 'prop-types';
import {
  CollapsibleHeaderProps,
  CollapsibleHeaderTextProps,
} from '../../types/collapsibleHeader.types';

const CollapsibleHeaderText = ({
  fontSize,
  text,
}: CollapsibleHeaderTextProps) => (
  <H2 fontWeight="bold" fontSize={fontSize}>
    {text}
  </H2>
);

CollapsibleHeaderText.propTypes = {
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  text: PropTypes.string.isRequired,
};

/*
Displays a collapsible header when enabled,
otherwise displays a read-only header
*/

export const CollapsibleHeader = ({
  text,
  // changed to fontSize to clarify visage -> swan intent in implementations
  fontSize,
  enabled,
  onClick,
  isOpen,
  contentId,
  testId,
}: CollapsibleHeaderProps) => {
  const iconType = isOpen ? 'caretUp' : 'caretDown';

  return enabled ? (
    <Button
      aria-expanded={isOpen}
      aria-controls={contentId}
      skin="unstyled"
      onClick={() => onClick()}
      data-testid={testId}
    >
      <FlexBox alignItems="center">
        <CollapsibleHeaderText fontSize={fontSize} text={text} />
        <Icon
          aria-hidden
          skin="standard"
          iconType={iconType}
          size="28p"
          pl={2}
          mb={2}
        />
      </FlexBox>
    </Button>
  ) : (
    <CollapsibleHeaderText fontSize={fontSize} text={text} />
  );
};

CollapsibleHeader.propTypes = {
  text: PropTypes.string.isRequired,
  fontSize: PropTypes.number.isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  contentId: PropTypes.string,
};
